import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Singapore FIN validator following Single Responsibility Principle
 */
export class FinValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Singapore FIN',
      pattern: /^[FG]\d{7}[A-Z]$/i,
      length: 9
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'FIN format must start with F or G, followed by 7 digits and a letter'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    const expectedChecksum = ChecksumCalculator.calculateNricChecksum(upperCaseId);
    const actualChecksum = upperCaseId.slice(-1);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(
        `Invalid FIN checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`
      );
    }

    return ValidationResult.valid('Valid FIN');
  }
}